import { useScrollReveal } from "@/hooks/useScrollReveal";
import JuicyButton from "@/components/base/JuicyButton";

const steps = [
  {
    num: "1",
    title: "「追加する」をクリック",
    desc: "下のボタンからDiscordの公式認証ページへ移動します。",
  },
  {
    num: "2",
    title: "サーバーを選択",
    desc: "追加したいサーバーをドロップダウンから選びます。",
  },
  {
    num: "3",
    title: "権限を承認",
    desc: "必要な権限を確認して「認証」をクリックします。",
  },
  {
    num: "4",
    title: "すぐ使える",
    desc: "「/timetable today」と入力して時間割を確認しましょう。",
  },
];

export default function IntegrationSection() {
  const { ref: headRef, visible: headVisible } = useScrollReveal();
  const { ref: stepsRef, visible: stepsVisible } = useScrollReveal();
  const { ref: ctaRef, visible: ctaVisible } = useScrollReveal();

  return (
    <section id="integration" className="py-32 px-6 bg-gray-950">
      <div className="max-w-6xl mx-auto">
        <div
          ref={headRef}
          style={{
            opacity: headVisible ? 1 : 0,
            transform: headVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
          }}
        >
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-white/30 mb-4">導入方法</p>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-20">
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
              1分で導入完了。
            </h2>
            <p className="text-white/40 text-sm max-w-xs leading-relaxed">
              コーディング不要。設定ファイルも不要。ボタンを押すだけで時間割くんがサーバーに参加します。
            </p>
          </div>
        </div>

        {/* Steps */}
        <div
          ref={stepsRef}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20"
        >
          {steps.map((s, i) => (
            <div
              key={s.num}
              className="relative"
              style={{
                opacity: stepsVisible ? 1 : 0,
                transform: stepsVisible ? "translateY(0)" : "translateY(24px)",
                transition: `opacity 0.7s ease-out ${i * 0.12}s, transform 0.7s ease-out ${i * 0.12}s`,
              }}
            >
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-5 left-full w-full h-px bg-white/10 z-0" />
              )}
              <div className="relative z-10">
                <div className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center mb-5">
                  <span className="text-white/60 text-sm font-mono">{s.num}</span>
                </div>
                <h3 className="text-white font-semibold text-sm mb-2">{s.title}</h3>
                <p className="text-white/40 text-xs leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA block */}
        <div
          ref={ctaRef}
          className="bg-white rounded-3xl p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-8"
          style={{
            opacity: ctaVisible ? 1 : 0,
            transform: ctaVisible ? "translateY(0)" : "translateY(24px)",
            transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
          }}
        >
          <div>
            <h3 className="text-black text-2xl md:text-3xl font-black mb-2">
              今すぐ無料で使える
            </h3>
            <p className="text-gray-500 text-sm">このサイトからいつでも時間割を確認できます</p>
          </div>
          <JuicyButton
            as="a"
            href="#timetable"
            particleColor="#ffffff"
            className="inline-flex items-center gap-2 bg-black text-white font-semibold text-sm px-8 py-3.5 rounded-full whitespace-nowrap cursor-pointer hover:bg-gray-800 transition-colors duration-200 flex-shrink-0"
          >
            <i className="ri-calendar-check-line text-base"></i>
            時間割を見る
          </JuicyButton>
        </div>
      </div>
    </section>
  );
}
